export const environment = {
  production: false,
  root_uri: "https://dev.kingtrivia.com",
  host: "devhost.kingtrivia.com",
  api_domain: "dev.kingtrivia.com",
  ws: { protocol: "wss" }
};
